import React from 'react';
import { Button } from '../button/index.js';
import { ModalDialog, Dialog } from '../dialog/index.js';
import { ProgressionBar } from '../progression-bar/index.js';

function getPercentage(maximum, achieved) {
    return Math.round((achieved / maximum) * 100);
}
function ConfirmationDialog({ id, onClose, material, translations, session, onConfirm, isOwner, }) {
    if (!session.result)
        throw new Error('Session result is missing');
    return (React.createElement(ModalDialog, { id: id, onClose: onClose, closeTitle: translations.actions.close, closeViaEscape: true, className: 'exercise-dialogs' },
        React.createElement(Dialog.Header, { title: translations.title }),
        React.createElement(Dialog.Body, { "data-testid": 'confirmation-dialog-body' },
            material.userMaxScore && !session.result?.needsGrading && (React.createElement("p", null,
                translations.body.scorePrefix,
                React.createElement("b", null,
                    getPercentage(session.result.score.maximum, session.result.score.achieved),
                    "%"),
                ".")),
            material.assignment && !material.assignment.repeatable ? (React.createElement("p", null, translations.body.notRepeatable)) : (React.createElement("p", null, translations.body.repeatable)),
            React.createElement("p", null, translations.body.currentResult),
            React.createElement(ProgressionBar, { maximum: session.result.score.maximum, achievable: session.result.score.achievable, achieved: session.result.score.achieved, translations: translations.body.progression, pending: session.result.needsGrading ? session.result.score.maximum : 0 })),
        React.createElement(Dialog.Footer, { "data-testid": 'confirmation-dialog-footer' },
            React.createElement(Button, { variant: 'secondary', onClick: onClose }, translations.actions.cancel),
            (isOwner || !material.assignment || material.assignment.repeatable) && (React.createElement(Button, { variant: 'primary', onClick: onConfirm }, translations.actions.restart)))));
}

export { ConfirmationDialog as default };
